import React from "react";
import { Link, Box, Typography } from "@mui/material";
import CreateIcon from '@mui/icons-material/Create';
import PlayLessonIcon from '@mui/icons-material/PlayLesson';
import DeleteIcon from '@mui/icons-material/Delete';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import { course as courseConst } from '../../pages/course/constants';


const StandardCard = ({ data, onDelete, editDiagnostic, lessonIcon, editCourse, assessmentIcon, diagnostic = false }) => {
    const badgeStyles = data && data.status?.toLowerCase() === "active" ? styles.badgeGreen : styles.badgeOrange;

    return (
        <Box
            sx={{
                borderRadius: '10px',
                background: 'var(--mui-palette-gray-lightGray50)',
                boxShadow: '0 5px 10px rgba(0, 0, 0, 0.1)',
                maxWidth: '400px',
                padding: '15px 15px 7px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                transition: 'all .5s ease-in-out',
                position: 'relative',
                overflow: 'hidden',
                '&:hover': {
                    background: 'var(--mui-palette-primary-blue)',
                    boxShadow: '0 20px 40px rgba(61,65,84,.15)',
                    transform: 'translateY(-2px)',
                    transition: 'all .5s ease-in-out',
                    '& h6, & a, & .MuiSvgIcon-root, & .MuiBox-root': {
                        color: 'var(--mui-palette-common-white)',
                    }
                },
                '&::before': {
                    content: '""',
                    display: 'block',
                    height: '5px',
                    width: 0,
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    backgroundColor: 'var(--mui-palette-primary-orange)',
                    transition: 'all .5s ease-in-out',
                },
                '&:hover:before': {
                    width: '100%',
                },
                '& > *': {
                    position: 'relative',
                    zIndex: 1,
                },
            }}
        >
            <Box>
                {data && data.courseName && (
                    <Typography
                        color="common.black"
                        align="left"
                        variant="h6"
                        sx={{
                            mb: 1.2,
                            fontSize: '1rem',
                            lineHeight: 1.4,
                            minHeight: '40px',
                            fontWeight: 'bold',
                            display: '-webkit-box',
                            WebkitBoxOrient: 'vertical',
                            WebkitLineClamp: 2,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            paddingRight: '50px'
                        }}
                    >
                        {data.courseName}
                    </Typography>
                )}
                {data && data.text && (
                    <Typography
                        color="common.black"
                        align="left"
                        variant="h6"
                        sx={{
                            mb: 1.2,
                            fontSize: '1rem',
                            lineHeight: 1.4,
                            minHeight: '40px',
                            fontWeight: 'bold',
                            display: '-webkit-box',
                            WebkitBoxOrient: 'vertical',
                            WebkitLineClamp: 2,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            paddingRight: '50px'
                        }}
                    >
                        {data.text}
                    </Typography>
                )}
                <Box sx={styles.courseDetail}>
                    {data && (data.status || data.courseStatus || data.studentType) && (
                        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', flexWrap: 'wrap', gap: 1, mb: '10px' }}>
                            {data.status && (
                                <Box sx={{ ...styles.badge, ...badgeStyles, marginRight: 0 }}>{data.status}</Box>
                            )}
                            {data.courseStatus && (
                                <Box sx={{ ...styles.badge, ...badgeStyles, marginRight: 0 }}>{data.courseStatus}</Box>
                            )}
                            {data.studentType && (
                                <Box sx={{
                                    ...styles.badge,
                                    marginRight: 0,
                                    ...(String(data.studentType).toUpperCase() === 'RURAL'
                                        ? styles.badgeGreen
                                        : styles.badgeOrange),
                                }}>
                                    {courseConst.STUDENT_TYPE[data.studentType] || data.studentType}
                                </Box>
                            )}
                        </Box>
                    )}
                    {data && data.taxonomy && (
                        <Box sx={styles.detailItem}>
                            <Box sx={styles.itemHeading}>Taxonomy11:</Box>
                            <Box sx={styles.itemValue}>{data.taxonomy}</Box>
                        </Box>
                    )}
                    {data && data.application && (
                        <Box sx={styles.detailItem}>
                            <Box sx={styles.itemHeading}>Location:</Box>
                            <Box sx={styles.itemValue}>{data.location}</Box>
                        </Box>
                    )}
                    {data && data.type && (
                        <Box sx={styles.detailItem}>
                            <Box sx={styles.itemHeading}>Mode:</Box>
                            <Box sx={styles.itemValue}>{courseConst.MODES[data.courseMode]}</Box>
                        </Box>
                    )}
                    {data && data.category && (
                        <Box sx={styles.detailItem}>
                            <Box sx={styles.itemHeading}>Session Time:</Box>
                            <Box sx={styles.itemValue}>{data.duration?.[0]?.sessionTime}</Box>
                        </Box>
                    )}
                </Box>
            </Box>
            <Box sx={styles.actionBtn}>
                {editDiagnostic && (
                    <Link style={styles.actionBtnItem} href={editDiagnostic} title="Edit Diagnostic Test"><CreateIcon sx={{ color: 'var(--mui-palette-primary-button)', fontSize: '1.2rem' }} /></Link>
                )}
                {editCourse && (
                    <Link style={styles.actionBtnItem} href={editCourse} title="Edit Course"><CreateIcon sx={{ color: 'var(--mui-palette-primary-button)', fontSize: '1.2rem' }} /></Link>
                )}
                {lessonIcon && (
                    <Link style={styles.actionBtnItem} href={lessonIcon} title="Lesson Plan"><PlayLessonIcon sx={{ color: 'var(--mui-palette-success-dark)', fontSize: '1.2rem', marginLeft: '5px' }} /></Link>
                )}
                {/* {assessmentIcon && (
                    <Link style={styles.actionBtnItem} href={assessmentIcon} title="Assessment"><FactCheckIcon sx={{ color: 'var(--mui-palette-warning-main)', fontSize: '1.2rem', marginLeft: '5px' }} /></Link>
                )} */}
                <Link style={styles.actionBtnItem} onClick={onDelete} title={editCourse ? "Delete Course" : "Delete Diagnostic Test"}>
                    <DeleteIcon sx={{ color: 'var(--mui-palette-error-main)', fontSize: '1.2rem' }} />
                </Link>
            </Box>
        </Box>
    );
}

const styles = {
    courseDetail: {
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'column',
        marginTop: '15px',
    },
    detailItem: {
    },
    itemHeading: {
        color: 'var(--mui-palette-primary-blue)',
        fontSize: '0.8rem',
        fontWeight: 600,
        marginBottom: '5px',
    },
    itemValue: {
        display: '-webkit-box',
        WebkitBoxOrient: 'vertical',
        WebkitLineClamp: 2,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        fontSize: '0.9rem',
        minHeight: '32px'
    },
    badge: {
        padding: '6px 10px',
        backgroundColor: 'var(--mui-palette-primary-orange)',
        marginRight: '1rem',
        borderRadius: '6px',
        fontSize: '.7rem',
        fontWeight: '600',
        letterSpacing: '0.5px'
    },
    badgeGreen: {
        backgroundColor: 'var(--mui-palette-primary-dark)',
        color: 'var(--mui-palette-common-white)',
    },
    badgeOrange: {
        color: 'var(--mui-palette-common-white)',
        backgroundColor: 'var(--mui-palette-primary-orange)',
    },
    actionBtn: {
        textAlign: 'right',
        position: 'absolute',
        top: '10px',
        right: '5px',
        padding: '5px',
        display: 'flex'
    },
    actionBtnItem: {
        marginLeft: '5px',
        marginRight: '5px',
        cursor: 'pointer'
    }
};

export default StandardCard;
